/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dashfix_Routing_One_No_FailoverInputs */

const en_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lane · no failover`)
};

const zh_hans1_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个数据源 · 无自动切换`)
};

const pt_br2_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fonte · sem failover`)
};

const es_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fuente · sin respaldo`)
};

const fr_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} source · sans basculement`)
};

const de_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Quelle · kein Failover`)
};

const ru_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} источник · без переключения`)
};

const it_dashfix_routing_one_no_failover = /** @type {(inputs: Dashfix_Routing_One_No_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} fonte · nessun failover`)
};

/**
* | output |
* | --- |
* | "{count} lane · no failover" |
*
* @param {Dashfix_Routing_One_No_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_routing_one_no_failover = /** @type {((inputs: Dashfix_Routing_One_No_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Routing_One_No_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_routing_one_no_failover(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_routing_one_no_failover(inputs)
	if (locale === "es") return es_dashfix_routing_one_no_failover(inputs)
	if (locale === "fr") return fr_dashfix_routing_one_no_failover(inputs)
	if (locale === "de") return de_dashfix_routing_one_no_failover(inputs)
	if (locale === "ru") return ru_dashfix_routing_one_no_failover(inputs)
	if (locale === "it") return it_dashfix_routing_one_no_failover(inputs)
	return en_dashfix_routing_one_no_failover(inputs)
});